import type { FC } from 'react';

import { connect } from 'react-redux';
import { compose } from 'recompact';

import type { RootState } from 'src/app/state/store';

function makeMapStateToProps() {
  return (state: RootState) => {
    const preferredLocation = state?.location?.preferredLocation;
    return {
      preferredLocation,
    };
  };
}

/**
 * Injects a prop, `preferredLocation`, to the base component
 * preferredLocation: "DEFAULT" | "NYC" | "WDC" | string
 */
export const withPreferredLocation = (BaseComponent: FC): FC => {
  return compose(connect(makeMapStateToProps, null))(BaseComponent);
};
